/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("zrx-slider-item-added", function (e) {
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
});

function policyCheck(form) {
  if(form.querySelector('.policy-checkbox').checked) {
   	return true 
  } else {
   	form.querySelector('.policy-error').style.display = 'block';
    return false;
  }
}

//document.querySelector('#purchase-btn').on

/*
if(document.URL == 'https://www.lovie.shop/') {
  animateTitle('התאהבות מובטחת')
}
*/
function animateTitle(newTitle) {
  let currentState = false;
  origTitle = 'שרשראות של לאבי במבחר היסטרי';  // save original title
  animatedTitle = newTitle
  timer = setInterval(startAnimation, 2000);

  function startAnimation() {
    // animate between the original and the new title
    document.title = currentState ? origTitle : animatedTitle;
    currentState = !currentState;
  }
}

const anc = document.querySelector('.AnnouncementBar__Content')
const text_container = anc.querySelector('a');

const first_text = text_container.textContent
const second_text = document.querySelector('#second-anc-text').textContent;

animateAnc();

function animateAnc() {
  let currentState = false;
  timer = setInterval(startAnimation, 5000);

  function startAnimation() {
    text_container.textContent = currentState ? first_text : second_text;
    currentState = !currentState;
  }
}

const necklace_length_input = document.querySelector('#necklace_length')
const variant_options = document.querySelectorAll('.variant-btn')

if(variant_options[0] != null) {
	necklace_length_input.value = variant_options[0].innerText;
}

variant_options.forEach(item => {
  item.addEventListener('click', function() {
   	 necklace_length_input.value = item.innerText;
      variant_options.forEach(item2 => {
        item2.classList.remove('selected')
      })
     item.classList.add('selected')
  }) 
})

window.addEventListener('load', function () {
  const pplr_c_button = document.querySelector('.pplr-c-button')
  if (pplr_c_button != null) {
    pplr_c_button.addEventListener('click', () => {
      const pplr_texts = document.querySelectorAll('.pplr_text')
      pplr_texts.forEach(input => {
        input.addEventListener('change', () => {
          let str = input.value
          console.log(str)
          str = str.replace(/[^0-9a-zA-Z\.]+/g,'');
          input.value = str
        })
      })
    })
  }
})
  
